export default __webpack_public_path__ + "static/switch-a09af1a5127e2c74448b2f74207d5dea.mp3";